export default "__VITE_ASSET__CU8eBq47__"